<mat-sidenav-container class="sggs-sidenav-container">
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <div class="sggs-dashboard-content">
      <div class="carousel-wrapper">
        <ng-container *ngIf="isDynamicSlidesLoading">
          <div class="carousel-loader-wrapper animate"></div>
        </ng-container>
        <ng-container *ngIf="!isDynamicSlidesLoading">
          <owl-carousel-o
            [options]="customOptions"
            (translated)="getPassedData($event)"
            (initialized)="getData($event)"
            #mainCarousel
          >
            <ng-container *ngIf="dynamicSlides.length">
              <ng-container *ngFor="let slide of dynamicSlides">
                <ng-template carouselSlide [id]="slide.SikhriEventID">
                  <div
                    style="background-image: url('{{ slide.ImageURL }}'); "
                    class="carousel-text-wrapper carousel-text-wrapper-home"
                  >
                    <div class="carousel-heading">{{ slide.Heading }}</div>
                    <div class="carousel-sub-heading">
                      {{ slide.SubHeading }}
                    </div>
                  </div>
                </ng-template>
              </ng-container>
            </ng-container>
          </owl-carousel-o>
          <div class="main-carousel-nav">
            <div class="carousel-nav-control" (click)="mainCarousel.prev()">
              <span> &#8249; </span>
            </div>
            <div class="carousel-nav-control" (click)="mainCarousel.next()">
              &#8250;
            </div>
          </div>
        </ng-container>
      </div>

      <div id="targetRed" class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait" #target>
        <div class="search-section">
          <h1 class="visually-hidden">{{"search_placeholder" | translate }}</h1>
          <div class="search-field-wrapper">
            <mat-form-field appearance="outline">
              <mat-label>{{"search_placeholder" | translate }}</mat-label>
              <input
                #searchInput
                [(ngModel)]="searchParams.text"
                matInput
                placeholder="{{'search_placeholder' | translate }}..."
              />
            </mat-form-field>
            
          </div>
          <div class="search-chips-wrapper" style="display: block;">
            <mat-chip-set
              class="example-chip"
              cdkDropListOrientation="horizontal"
            >
              <mat-chip (click)="searchType('Author')" [class.active-word]="textParam.type === 'Author'" class="tag-box"> {{ "Author" | translate }} </mat-chip>
              <mat-chip (click)="searchType('PageNumber')" [class.active-word]="textParam.type === 'PageNumber' || textParam.type === 'Pagenumber'" class="tag-box"> {{ "Page Number" | translate }} </mat-chip>
              <mat-chip (click)="searchType('Keyword')" [class.active-word]="textParam.type === 'Keyword'" class="tag-box"> {{ "Keyword" | translate }} </mat-chip>
              <mat-chip (click)="searchType('SabadTitle')" [class.active-word]="textParam.type === 'SabadTitle'" class="tag-box"> {{ "Sabad Title" | translate }} </mat-chip>
              <mat-chip (click)="searchType('Tags')" [class.active-word]="textParam.type === 'Tags'" class="tag-box"> {{ "Tags" | translate }} </mat-chip>
            </mat-chip-set>
            <div *ngIf="showAllWord || showAllBani" style="text-align: right;position: relative;bottom: 40px;">
              <button
              (click)="back()"
                class="sggs-primary-button"
                mat-stroked-button
                color="primary"
              >
                {{ "Back" | translate }}
              </button>
            </div>
          </div>
        </div>

        <div class="featured-wrapper">
          <div
            class="search-results-section"
            *ngIf="!showAllWord"
            [hidden]="!showAllBani"
            [hidden]="textParam?.keyword || searchParams.text"
            [class.is-mobile]="isHandsetPortrait"
          >
            <div class="results-info-left">
              {{ totalRecords }}
              {{ totalRecords > 1 ?  ('results' | translate ) : ( 'result' | translate ) }} {{'found' | translate }} {{'on_search' | translate}}
            </div>
           
            <div
              class="filter-info-right"
              [class.is-mobile]="isHandsetPortrait"
            >
              <button
                mat-stroked-button
                class="sort-info-button grey-button"
                [class.is-selected]="searchParams.dateSort"
                (click)="toggleSortOptions(sortTypes.DATE)"
              >
              <!-- {{"Newest_to_Oldest" | translate }} -->
               <span *ngIf="searchParams.dateSort === 'desc'">{{"Newest_to_Oldest" | translate }}</span> 
               <span *ngIf="searchParams.dateSort === 'asc' || searchParams.dateSort === ''">{{"Oldest_to_Newest" | translate }}</span> 
                <mat-icon *ngIf="searchParams.dateSort === 'asc'"
                  >arrow_downward</mat-icon
                >
                <mat-icon *ngIf="searchParams.dateSort === 'desc'"
                  >arrow_upward</mat-icon
                >
              </button>
              <button
                mat-stroked-button
                class="sort-info-button grey-button"
                [class.is-selected]="searchParams.alphabeticSort"
                (click)="toggleSortOptions(sortTypes.ALPHABETIC)"
              >
                <mat-icon *ngIf="searchParams.alphabeticSort === 'desc'"
                  >arrow_downward</mat-icon
                >
                <mat-icon *ngIf="searchParams.alphabeticSort === 'asc'"
                  >arrow_upward</mat-icon
                >
                {{"A_Z" | translate }}
              </button>

              <!-- <button
                class="search-filter-button"
                mat-flat-button
                color="primary"
                [matMenuTriggerFor]="filterMenu"
              >
                <mat-icon>filter_list_alt</mat-icon>
              </button> -->
              <!-- [hasBackdrop]="false" -->
              <!-- <mat-menu #filterMenu="matMenu">
                <div class="filter-wrapper">
                  <div class="filter-field">
                    <div class="filter-label">{{"By_Poet" | translate }}</div>
                    <div class="filter-item">
                      <mat-form-field
                        (click)="$event.stopPropagation()"
                        appearance="outline"
                        class="filter-list-class"
                      >
                        <mat-label
                          >{{"Choose_an_option" | translate}} &nbsp;&nbsp;&nbsp;&nbsp;
                        </mat-label>
                        <mat-select
                          (click)="$event.stopPropagation()"
                          class="filter-dropdown-class"
                          panelClass="auto-height"
                          disableOptionCentering
                        >
                          <mat-option value="option1">{{ "All" | translate }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </mat-menu> -->
            </div>
          </div>
          <!-- search results configuration buttons stop -->
          <mat-accordion multi *ngIf="searchParams?.text?.trim() || textParam?.keyword">
            <mat-expansion-panel class="pt-30"  *ngIf="!showAllWord && !showAllBani && dictionaryDetails?.length" [expanded]="true" >
              <mat-expansion-panel-header class="expansion-header panel-title">
                <mat-panel-title class="panel-title">
                  {{"Dictionary" | translate }}
                </mat-panel-title>
                <!-- <mat-panel-description>
                Currently I am {{panelOpenState ? 'open' : 'closed'}}
                </mat-panel-description> -->
              </mat-expansion-panel-header>
              
              <div *ngIf="dictionaryDetails?.length" class="dictionary-details">
                <div class="mt-2"><strong>{{dictionaryDetails[0].WordName}}</strong></div>
                <div class="mt-1">{{dictionaryDetails[0].WordMeaning}}</div>
                <div class="mt-2"><span class="text-secondary">Grammar</span> &nbsp;{{dictionaryDetails[0].WordGrammar}}</div>
                <div class="mt-1"><span class="text-secondary">Etymology</span> &nbsp;{{dictionaryDetails[0].WordEtymology}}</div>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="Word-Instance pt-30" *ngIf="!showAllBani && wordInstanceDetails?.length" [expanded]="true">
              <mat-expansion-panel-header class="expansion-header panel-title">
                <mat-panel-title class="panel-title">
                 {{ "Word_Instance"  | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header >
              <div *ngIf="!showAllWord" class="mt-4" style="text-align: right;">
                <button
                (click)="moreWord();showAllWord = true"
                  class="sggs-primary-button"
                  mat-stroked-button
                  color="primary"
                >
                  {{ "View More" | translate }}
                </button>
              </div>
              <div [ngClass]="!i ? 'mt-2' : ''"  *ngFor="let word of wordInstanceDetails;let i = index" (click)="navigate(word)"
                class="term-details-wrapper 1 cursor-pointer"
              >
                <div class="terms-details">
                  <div class="term-description"> <!-- [innerHtml]="word.SubSectionContent" -->
                    <!-- {{ word.SubSectionContent }} -->
                    <span [innerHtml]="word.SubSectionContent"></span>
                    <a class="view-more-link">...{{word.BaniName}} > {{word.SectionName}} > {{word.SubSectionName}}</a>

                  </div>
                
                </div>
                <div class="term-expand-wrapper">
                  <div
                    class="term-expand-icon"
                  >
                    <mat-icon>keyboard_arrow_right</mat-icon>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>

          <div *ngIf="!showAllWord" [ngClass]="(!searchParams.text && !textParam?.keyword) ? '' : 'mt-60'" [class.is-mobile]="isHandsetPortrait">
            <div class="mb-2" *ngIf="(textParam?.keyword || searchParams?.text?.trim()) && tmpBaniSearchResults?.length! > 3" style="text-align: right;"
              [hidden]="showAllWord">
                <button
                  class="sggs-primary-button"
                  mat-stroked-button
                  color="primary"
                  *ngIf="!showAllBani && searchResults?.length"
                  (click)="moreBani();showAllBani = true"
                >
                  {{ "View More" | translate }} 
                </button>
              </div>
            <mat-grid-list cols="3" rowHeight="380px" gutterSize="15px">
              <ng-container *ngIf="isSearchResultsLoading">
                <mat-grid-tile *ngFor="let loading of [0, 1, 2, 3, 4, 5]"
                  ><div class="featured-post-wrapper">
                    <div class="featured-video-wrapper">
                      <div class="featured-video-thumbnail animate"></div>
                    </div>
                    <div class="featured-video-description">
                      <div class="featured-video-heading">
                        <div class="loading-heading animate"></div>
                      </div>
                      <div class="featured-video-sub-heading">
                        <div class="loading-line animate"></div>
                        <div class="loading-line animate"></div>
                        <div class="loading-line animate"></div>
                      </div>
                    </div></div
                ></mat-grid-tile>
              </ng-container>
              
              <ng-container *ngIf="!isSearchResultsLoading">
                
                <mat-grid-tile
                  colspan="{{ isHandsetPortrait ? 3 : 1 }}"
                  *ngFor="let result of searchResults"
                  >
                  
                <ng-container>
                  <div class="featured-post-wrapper">
                    <div
                      
                      (click)="openVideoPopup(result.BaniVideoURL)"
                      class="featured-video-wrapper"
                    > 
                      <div (click)="openBaniDashboard(result.BaniCode)" class="featured-video-thumbnail youtub-thumb" style="background-image: url('{{ fetchImageThumbnail(result) }}');" >
                        <!-- <img src="{{ fetchImageThumbnail(result) }} " /> -->
                        <div  *ngIf="result.BaniVideoURL" class="video-thumbnail-cover">
                          <img alt="play-button" src="/assets/images/play.webp" />
                        </div>
                      </div>
                    </div>

                    <a class="view-more-div" href="/bani/{{result.BaniCode}}">
                      <div
                        (click)="openBaniDashboard(result.BaniCode)"
                        class="featured-video-description"
                      >
                        <div class="featured-video-heading">
                          {{
                            result?.BaniName?.trim()
                              ? result.BaniName
                              : "In Progress"
                          }}
                        </div>
                        <div class="featured-video-sub-heading">
                          {{
                            result?.Introduction?.trim()
                              ? showSmallerString(result.Introduction)
                              : "Coming Soon"
                          }}
                          <span class="view-more-link"> {{"more" | translate }}... </span>
                        </div>
                      </div>
                    </a>
                  </div>
                </ng-container>
                  </mat-grid-tile
                >
              </ng-container>
            </mat-grid-list>
          </div>
         
        </div>
        <!--featured posts stop-->
       

       
      </div>
       <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
